let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g9GxH")).then(() => parcelRequire('1wlGP'));